<template>
    <v-dialog width="400" v-model="visible">
        <v-card>
            <v-card-title :class="color" class="headline lighten-2" primary-title>{{title}}</v-card-title>

            <v-card-text style="text-align: justify;">{{message}}</v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn :color="color" flat @click="close">
                    {{$t('OK')}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import { VDialog, VBtn, VCard, VCardTitle, VCardText, VDivider, VCardActions, VSpacer } from 'vuetify/lib'
    export default {
        name: "Modal",
        components: {
            VDialog, VBtn, VCard, VCardTitle, VCardText, VDivider, VCardActions, VSpacer
        },
        data: () => ({
            visible: false,
            title: "Title",
            message: "Message",
            color: "grey"
        }),
        methods: {
            show() {
                this.visible = true;
            },
            hide() {
                this.visible = false;
            },
            close() {
                this.hide();
            },
            setInformation(jInfo) {
                this.title = jInfo.title;
                this.message = jInfo.message;
                this.color = jInfo.type;
            }
        },
    };
</script>
<style>
    .modal-fade-enter,
    .modal-fade-leave-active {
        opacity: 0;
    }
    .modal-fade-enter-active,
    .modal-fade-leave-active {
        transition: opacity 0.3s ease;
    }
    .modal-backdrop {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 10;
    }
    .modal {
        background: #ffffff;
        box-shadow: 2px 2px 20px 1px;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
    }
</style>
